import React from "react"
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";
import {FilterExpander} from "../common/component/FilterExpander";

import DepartFilter from "./DepartFilter";
const DepartFilterWrapper = () => {

    const {isMobile} = useDeviceLayout()

    return (
        <React.Fragment>
            {isMobile ?
                <FilterExpander>
                    <DepartFilter />
                </FilterExpander> :
                <DepartFilter />}
        </React.Fragment>
    )

}
export default DepartFilterWrapper


// WEBPACK FOOTER //
// ./src/components/depart/DepartFilterWrapper.js